<template>
    <div style="position: relative; height: 100%;">
        <!-- Folder title and navigation -->
        <v-list-item v-if="!hideTitle" style="position: sticky; top: 48px; z-index: 9; height: 40px;"
            :style="'background: linear-gradient(180deg, ' + (hideFolders ? 'white, white, white, white,' : '#f7f7f7, #f7f7f7, #f7f7f7, #f7f7f7,') + ' transparent);'">
            <v-list-item-action v-if="!hideFolders" class="ma-0">
                <v-btn color="primary" :disabled="!(crumbs && (crumbs.length > 1))" icon small>
                    <v-icon @click="crumbs = []">mdi-chevron-double-left</v-icon>
                </v-btn>
            </v-list-item-action>
            <v-list-item-action v-if="!hideFolders" class="ma-0">
                <v-btn color="primary" :disabled="!(crumbs && crumbs.length)" icon small>
                    <v-icon @click="crumbs = crumbs.slice(0, (crumbs.length - 1))">mdi-chevron-left</v-icon>
                </v-btn>
            </v-list-item-action>
            <v-list-item-action class="ma-0">
                <v-icon v-if="folder.Files || (crumbs && crumbs.length)" size="20"
                    :class="hideFolders ? 'mr-2' : 'mx-2'">
                    mdi-folder-open
                </v-icon>
                <template v-else>
                    <div class="mx-2" style="position: relative;">
                        <v-icon size="22">mdi-folder</v-icon>
                        <v-icon size="10" color="white"
                            style="position: absolute; left: 5px; top: 6px;">mdi-file-tree</v-icon>
                    </div>
                </template>
            </v-list-item-action>
            <v-list-item-content class="py-0" style="padding-top: 2px !important;">
                <v-list-item-title style="font-size: medium;">
                    {{ crumbs && crumbs.length ? folderName(crumbs[crumbs.length - 1])
                        : (hideDirectFiles ? $t('servicesystem.common_objects.document.related folders') :
                            folderName(folder)) }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <!-- Sub-folders -->
        <template v-if="subFolders && !hideFolders">
            <template v-if="!targetFolder.FlattenFolders">
                <FileSectionHeader v-if="targetFolder.Files"
                    :text="$t('servicesystem.common_objects.document.related folders')" class="mt-1" />
                <div v-if="!targetFolder.foldersCollapsed" class="d-flex flex-wrap">
                    <template v-for="(subfolder, index) in subFolders">
                        <FolderThumb :key="index" :name="folderName(subfolder)"
                            :description="folderDescription(subfolder)" :fileCount="countNestedFiles(subfolder)"
                            :color="folderColor(subfolder)" :grid="grid" @click="crumbs.push(subfolder)">
                        </FolderThumb>
                    </template>
                </div>
            </template>
            <template v-else>
                <template v-for="(subfolder, index) in subFolders">
                    <div v-if="countNestedFiles(subfolder)" :key="index">
                        <FileSectionHeader v-model="subfolder.collapsed" :text="folderName(subfolder)"
                            :count="countNestedFiles(subfolder)" />
                        <div v-if="!subfolder.collapsed" class="d-flex flex-wrap mb-3">
                            <File v-for="(file, idx) in subfolder.Files" :key="folderName(subfolder) + '-' + idx"
                                :file="file" :grid="grid"
                                :selected="isSelectedByEntity(file, subfolder.InheritedFromType)" :selectable="true"
                                :entityName="subfolder.InheritedFromType" :defaultEmailTemplate="defaultEmailTemplate"
                                @ToggleSelect="({ file: f, selected }) => $emit('ToggleSelect', { file: f, selected, entityName: subfolder.InheritedFromType })"
                                @Delete="emitDelete" @TogglePublishToCustomer="emitTogglePublishToCustomer">
                            </File>
                        </div>
                    </div>
                </template>
            </template>
        </template>

        <!-- Files in this folder -->
        <template v-if="!targetFolder.FlattenFolders && (!hideDirectFiles || (crumbs && crumbs.length))">
            <v-row no-gutters>
                <FolderGrouping v-if="(typefilter == 'Media' || !typefilter)"
                    :title="$t('servicesystem.common_objects.document.media')" :list="media" :limitName="true"
                    :collapsed="targetFolder.mediaCollapsed" :grid="grid" :wide="wide" openPickerOnClick editable
                    :loading="targetFolder.loading0" :selectedKeys="selectedKeys" :entityName="entityNameForTarget"
                    :defaultEmailTemplate="defaultEmailTemplate" @ToggleSelect="$emit('ToggleSelect', $event)"
                    @File="f => upload(targetFolder, 0, f, null)"
                    @ExternalContent="e => upload(targetFolder, 0, null, e)" @Delete="emitDelete"
                    @TogglePublishToCustomer="emitTogglePublishToCustomer">
                </FolderGrouping>
                <v-divider v-if="wide" vertical class="mt-3"></v-divider>
                <FolderGrouping v-if="(typefilter == 1 || !typefilter)"
                    :title="$t('servicesystem.common_objects.document.documents')" :list="documents"
                    :limitName="targetFolder.InheritedFromType == 'Job'" :collapsed="targetFolder.documentsCollapsed"
                    :grid="grid" :wide="wide" editable :loading="targetFolder.loading1" :selectedKeys="selectedKeys"
                    :entityName="entityNameForTarget" :defaultEmailTemplate="defaultEmailTemplate"
                    @ToggleSelect="$emit('ToggleSelect', $event)" @File="f => upload(targetFolder, 1, f, null)"
                    @ExternalContent="e => upload(targetFolder, 1, null, e)" @Delete="emitDelete"
                    @TogglePublishToCustomer="emitTogglePublishToCustomer">
                </FolderGrouping>
                <template v-if="targetFolder.InheritedFromType != 'Job'">
                    <v-divider v-if="wide" vertical class="mt-3"></v-divider>
                    <FolderGrouping v-if="(typefilter == 2 || !typefilter)"
                        :title="$t('servicesystem.common_objects.document.forms')" :list="forms"
                        :collapsed="targetFolder.formsCollapsed" :grid="grid" :wide="wide" editable
                        :loading="targetFolder.loading2" :selectedKeys="selectedKeys" :entityName="entityNameForTarget"
                        :defaultEmailTemplate="defaultEmailTemplate" @ToggleSelect="$emit('ToggleSelect', $event)"
                        @File="f => upload(targetFolder, 2, f, null)"
                        @ExternalContent="e => upload(targetFolder, 2, null, e)" @Delete="emitDelete"
                        @TogglePublishToCustomer="emitTogglePublishToCustomer">
                        <template  v-slot:divider>
                            <v-row no-gutters align="center">
                                <v-col cols="0">
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="auto">
                                    <div v-if="formfillActive" class="d-flex secondary--text px-2">
                                        <v-icon color="secondary" size="18" class="mr-1">mdi-form-textbox-password</v-icon>
                                        Auto-fill on
                                    </div>
                                    <div v-else class="d-flex disabled--text px-2">
                                        <v-icon color="disabled" size="18"
                                            class="mr-1">mdi-form-textbox-password</v-icon>
                                        Auto-fill off
                                    </div>
                                </v-col>
                                <v-col cols="0">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </template>
                    </FolderGrouping>
                    <v-divider v-if="wide" vertical class="mt-3"></v-divider>
                    <FolderGrouping v-if="(typefilter == 3 || !typefilter)"
                        :title="$t('servicesystem.common_objects.document.part_drawings')" :list="partdrawings"
                        :collapsed="targetFolder.partdrawingsCollapsed" :grid="grid" :wide="wide"
                        :loading="targetFolder.loading3" :selectedKeys="selectedKeys" :entityName="entityNameForTarget"
                        :defaultEmailTemplate="defaultEmailTemplate" @ToggleSelect="$emit('ToggleSelect', $event)"
                        @Delete="emitDelete" @TogglePublishToCustomer="emitTogglePublishToCustomer">
                        <!-- no upload for partdrawings for now -->
                    </FolderGrouping>
                </template>
            </v-row>
        </template>
    </div>
</template>


<script>
import FolderMixin from "@/helpers/Mixins/FolderMixin.js";
import File from "@/views/pim/documents/File.vue";
import FileSectionHeader from "@/views/pim/documents/FileSectionHeader.vue";
import FolderGrouping from "@/views/pim/documents/FolderGrouping.vue";
import FolderThumb from "@/views/pim/documents/FolderThumb.vue";

export default {
    name: 'Folder',
    props: {
        folder: Object,
        totalSearchCount: Number,
        hideTitle: Boolean,
        grid: Boolean,
        wide: Boolean,
        defaultEmailTemplate: { type: Object, default: null },
        hideDirectFiles:
        {
            type: Boolean,
            default: false,
        },
        hideFolders:
        {
            type: Boolean,
            default: false,
        },
        typefilter: [String, Number],
        selectedKeys: { type: Set, default: null },
        formfillActive: { type: Boolean, default: false },
    },
    components: {
        FileSectionHeader,
        File,
        FolderThumb,
        FolderGrouping,
    },
    mixins: [FolderMixin],

    data() {
        return {
            crumbs: [],
        };
    },

    methods: {
        upload(folder, doctype, files, externalContent) {
            this.$emit('Upload', folder, doctype, files, externalContent);
        },

        emitDelete(file) {
            //console.log('emitDelete', this.targetFolder, file);
            if (this.targetFolder.InheritedFromType == 'MachineJobHistory') { //special handling to delete from job instead here
                var copy = Object.assign({}, this.targetFolder);
                copy.InheritedFromType = 'Job';
                copy.InheritedFromId = 0; //the id here doesnt matter for delete
                this.$emit('Delete', copy, file.TypeId, file.Id);
            }
            else {
                this.$emit('Delete', this.targetFolder, file.TypeId, file.Id);
            }
        },

        emitTogglePublishToCustomer(file) {
            if (this.targetFolder.InheritedFromType == 'MachineJobHistory') { //special handling to delete from job instead here
                var copy = Object.assign({}, this.targetFolder);
                copy.InheritedFromType = 'Job';
                copy.InheritedFromId = 0; //the id here doesnt matter
                this.$emit('TogglePublishToCustomer', copy, file);
            }
            else {
                this.$emit('TogglePublishToCustomer', this.targetFolder, file);
            }
        },

        isSelectedByEntity(file, entityName) {
            if (!this.selectedKeys) return false;
            const key = `${entityName}:${file.TypeId}:${file.Id}:${file.IsExternalContent ? 1 : 0}`;
            return this.selectedKeys.has(key);
        },
    },

    computed: {
        targetFolder() {
            var target = this.folder;
            const folderNameCheck = (a, b) => { return this.folderName(a) == this.folderName(b) }
            this.crumbs.forEach(crumb => {
                target = target.Folders.find(x => folderNameCheck(x, crumb));
            });
            return target;
        },

        subFolders() {
            var list = this.targetFolder.Folders;
            return list && list.length ? list : null;
        },

        media() {
            var list = this.filterFileArrByType(this.targetFolder.Files, 'Media')
            return list && list.length ? list : null;
        },
        documents() {
            var list = this.filterFileArrByType(this.targetFolder.Files, this.DocumentTypes.LINK)
            return list && list.length ? list : null;
        },
        forms() {
            var list = this.filterFileArrByType(this.targetFolder.Files, this.DocumentTypes.FORM)
            return list && list.length ? list : null;
        },
        partdrawings() {
            var list = this.filterFileArrByType(this.targetFolder.Files, this.DocumentTypes.PARTDRAWING)
            return list && list.length ? list : null;
        },

        entityNameForTarget() {
            return this.targetFolder?.InheritedFromType || '';
        },
    },

    watch: {},
};
</script>


<style lang='scss'>
.crumb,
.crumb i {
    color: rgb(78, 78, 173) !important;
    font-size: 12px;
}

.crumb.last,
.crumb.last i {
    color: rgb(80, 80, 80) !important;
}

/*
.crumbsbar {
    min-height: 0.1px;
    position: sticky;
    top: 48px;
    z-index: 9;
    box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
    background-color: white;
}
*/
</style>